import Vue from 'vue'
import VueCookies from 'vue-cookies';
import App from './App.vue'
import router from './router'
import VueAxios from 'vue-axios'
import axios from 'axios'


Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(VueCookies);

// Bootstrap removed, relying only on Vuetify
import vuetify from './plugins/vuetify'


new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
